import { ScreeningCheckInContinue } from '../../../../components/screening/screeningView/checkIn/ScreeningCheckInContinue'
import { ScreeningCheckInNotStarted } from '../../../../components/screening/screeningView/checkIn/ScreeningCheckInNotStarted'
import { ScreeningFollowUpCompleted } from '../../../../components/screening/screeningView/followUp/ScreeningFollowUpCompleted'
import { ScreeningFollowUpContinue } from '../../../../components/screening/screeningView/followUp/ScreeningFollowUpContinue'
import { ScreeningFollowUpNotStarted } from '../../../../components/screening/screeningView/followUp/ScreeningFollowUpNotStarted'
import { ScreeningFollowUpPending } from '../../../../components/screening/screeningView/followUp/ScreeningFollowUpPending'
import { ScreeningStandardCompleted } from '../../../../components/screening/screeningView/standard/ScreeningStandardCompleted'
import { ScreeningStandardContinue } from '../../../../components/screening/screeningView/standard/ScreeningStandardContinue'
import { ScreeningStandardNotStarted } from '../../../../components/screening/screeningView/standard/ScreeningStandardNotStarted'
import { ScreeningStandardPending } from '../../../../components/screening/screeningView/standard/ScreeningStandardPending'
import { useSelectScreeningStatus } from '../../../../state/selectors'
import { ScreeningStatus } from '@estercare/ester-shared'

const screeningComponentMap: Partial<Record<ScreeningStatus, JSX.Element>> = {
  [ScreeningStatus.NOT_STARTED]: <ScreeningStandardNotStarted />,
  [ScreeningStatus.RENEW]: <ScreeningStandardNotStarted />,
  [ScreeningStatus.INCOMPLETE]: <ScreeningStandardContinue />,
  [ScreeningStatus.PENDING]: <ScreeningStandardPending />,
  [ScreeningStatus.HANDLED]: <ScreeningStandardCompleted />,
  [ScreeningStatus.CHECK_IN_NOT_STARTED]: <ScreeningCheckInNotStarted />,
  [ScreeningStatus.CHECK_IN_INCOMPLETE]: <ScreeningCheckInContinue />,
  [ScreeningStatus.FOLLOW_UP_NOT_STARTED]: <ScreeningFollowUpNotStarted />,
  [ScreeningStatus.FOLLOW_UP_INCOMPLETE]: <ScreeningFollowUpContinue />,
  [ScreeningStatus.FOLLOW_UP_PENDING]: <ScreeningFollowUpPending />,
  [ScreeningStatus.FOLLOW_UP_HANDLED]: <ScreeningFollowUpCompleted />,
}

export const Screening = () => {
  const screeningStatus = useSelectScreeningStatus()

  if (!screeningStatus) return null

  return screeningComponentMap[screeningStatus] ?? null
}
